export const uppercase = value => value.toUpperCase();
